import React from 'react';
import { Parallax } from 'react-scroll-parallax';
import './About.css';

const AboutContent = (props) => (
    <Parallax
        disabled={props.isDisabled}
        className="about-frame"
        offsetYMax={75}
        offsetYMin={-75}
    >
        <div className="about-frame__inner">
            <div>
                <h1>{props.title}</h1>
                <p className="bigger">{props.description}</p>
            </div>
        </div>
    </Parallax>
)

export default AboutContent;


// WEBPACK FOOTER //
// ./src/About/AboutContent.js